var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles/';
import { Dialog, DIALOG_IMAGE_HEIGHT, DIALOG_IMAGE_HEIGHT_XL, DIALOG_WIDTH, DIALOG_WIDTH_XL, TwitterEllipseButton, } from '@lean-body/components/molecules';
import { Textarea, CanvasWithCenterImage } from '@lean-body/components/atoms';
import { canvasToFile } from '@lean-body/src/util/canvas';
import { CloseButtonLabel } from '../atoms/dialog_close_button';
import { useXlMediaQuery } from '@lean-body/src/util';
const MAX_TWEET_TEXT = 140;
export const TwitterFormDialog = ({ defaultText, onClickCancel, imageURL, submit, imgWidth, imgHeight, centerImageWidth, aspectRatio, closeButtonLabel, strictSameSize, }) => {
    const isXL = useXlMediaQuery();
    const canvas = React.useRef();
    const [tmpText, setTmpText] = React.useState(defaultText);
    const [warningText, setwarningText] = React.useState('');
    const [file, setFile] = React.useState(null);
    const onChange = (event) => {
        setTmpText(event.target.value);
    };
    const onClickSubmit = () => __awaiter(void 0, void 0, void 0, function* () {
        if (tmpText.replace(/\n/g, '').length > MAX_TWEET_TEXT) {
            setwarningText(`${MAX_TWEET_TEXT}文字以上は入力できません。`);
            return;
        }
        yield submit(tmpText, file);
        close();
    });
    const onLoad = () => __awaiter(void 0, void 0, void 0, function* () {
        const canvasFile = yield canvasToFile(canvas.current, 'img_file.jpg', 'image/jpg');
        setFile(canvasFile);
    });
    return (React.createElement(Dialog, { closeButtonLabel: closeButtonLabel || CloseButtonLabel.Cancel, onClickCancel: onClickCancel, disableBackgroundCancel: true, isCloseButton: true, strictSameSize: strictSameSize, content: React.createElement("div", { className: css(styles.container) },
            React.createElement(CanvasWithCenterImage, { ref: canvas, imgSrc: imageURL, width: imgWidth || (isXL ? DIALOG_WIDTH_XL : DIALOG_WIDTH), height: imgHeight || (isXL ? DIALOG_IMAGE_HEIGHT_XL : DIALOG_IMAGE_HEIGHT), centerImageWidth: centerImageWidth || (isXL ? DIALOG_WIDTH_XL : DIALOG_WIDTH), aspectRatio: aspectRatio, onLoad: onLoad, classObject: styles.canvas }),
            React.createElement("div", { className: css(styles.tweetArea) },
                React.createElement(Textarea, { className: css(styles.textarea), onChange: onChange, value: tmpText, placeholder: 'ツイートする文言を入力しよう！' }),
                warningText.length > 0 && React.createElement("div", { className: css(styles.warningText) }, warningText),
                React.createElement("div", { className: css(styles.buttonOuter) },
                    React.createElement(TwitterEllipseButton, { text: 'ポストする', onClick: onClickSubmit, classObject: styles.button })))) }));
};
const styles = StyleSheet.create({
    container: {
        height: '100%',
        borderRadius: 8,
        overflow: 'hidden',
    },
    tweetArea: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: '16px 18px 20px',
    },
    textarea: {
        width: '100%',
        height: 134,
        minHeight: '54.5px',
        fontSize: 14,
        padding: 16,
        backgroundColor: Colors.BackgroundLightGray,
        borderRadius: 4,
        border: 'none',
        '::placeholder': {
            color: Colors.GrayDarkest,
        },
    },
    warningText: {
        height: 20,
        fontSize: 12,
        color: Colors.Red,
        textAlign: 'center',
        marginTop: 16,
    },
    buttonOuter: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 16,
        width: '100%',
    },
    button: {
        width: '100%',
        [MediaBreakPointUp.XL]: {
            width: 'auto',
            minWidth: 290,
        },
    },
    canvas: {
        borderRadius: '8px 8px 0 0',
    },
});
